module.exports = __webpack_public_path__ + "media/fresh/female-student-backpack@2x-a99059f0.png";